/* eslint-disable react/jsx-one-expression-per-line */
import { t } from "@lingui/macro";
import Big from 'big.js';
import dayjs from 'dayjs';
import React from 'react';
import { StorageKey } from "../../../enums/StorageKey";
import { store } from "../../../redux/store";
import BankFeedTransactionListMenu from '../../ListMenu/BankFeedTransaction';
import AmountTd from "../../Table/Common/AmountTd";
import { ActionTdSmallWidth } from "../../Table/Common/CommonWidths";

function getColumns(props) {
    const {
        currency_symbol,
        hasUpdateAccess,
    } = props;

    const parsedHasUpdateAccess = store ? hasUpdateAccess : true;

    const columns = [
        {
            title: t`Date`,
            dataIndex: 'date',
            key: 'date',
            width: 100,
            render: (text, record) => (dayjs(record.date).format('DD/MM/YYYY')),
        },
        {
            title: t`Description`,
            dataIndex: 'description',
            key: 'description',
            width: 180,
            align: 'left',
            // render: text => (
            //     <div className="small-text">
            //         {text}
            //     </div>
            //     // <BukkuTooltip title={text}>
            //     // <div className="ellipsis-div">
            //     //     {text}
            //     // </div>
            //     // </BukkuTooltip>
            // ),
        },
        {
            title: t`Spent`,
            dataIndex: 'debit_amount',
            key: 'debit_amount',
            width: 100,
            render: text => {
                if (!text || Big(text || 0).eq(0))
                    return null;

                return <AmountTd
                    amount={Big(text).toNumber()}
                    currency_symbol={currency_symbol}
                />;
            },
        },
        {
            title: t`Received`,
            dataIndex: 'credit_amount',
            key: 'credit_amount',
            width: 100,
            render: text => {
                if (!text || Big(text || 0).eq(0))
                    return null;

                return <AmountTd
                    amount={Big(text).toNumber()}
                    currency_symbol={currency_symbol}
                />;
            },
        },

    ];

    if (parsedHasUpdateAccess) {
        columns.push(
            {
                title: t`Action`,
                key: 'action',
                width: ActionTdSmallWidth,
                render: (text, record) => (
                    <BankFeedTransactionListMenu
                        record={record}
                        currency_symbol={currency_symbol}
                    />
                ),
            },
        );
    }

    return columns;
}

export default {
    storageKey: StorageKey.bank_feed_transaction,
    sortable: [
        'date',
        // 'description',
        'debit_amount',
        'credit_amount',
    ],
    required: [
        'date',
        'description',
        'debit_amount',
        'credit_amount',
        'action',
    ],
    defaulto: [
    ],
    hideTitle: [
    ],
    getColumns,
};
